// Third-party libraries
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Textarea from "react-textarea-autosize";
import ReactTags from "react-tag-autocomplete";

// Project dependencies
import { Meta } from "../utilities";
import { getHeaders, leagueUrl, playerUrl, errorHandler } from "../apihelpers";
import { LoadingBar } from "../components/widgets";

class Leagues extends Component {
  state = {
    league_created: false,
    name: "",
    welcome: "",
    name_error: false,
    welcome_error: false,
    players: [],
    invitees: [],
    loading: false,
  };

  welcome_max = 300;

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let state = {};
    state[name] = value;
    if (name === "welcome" && value.length >= 300) {
      state[name] = value.substr(0, this.welcome_max);
      state.welcome_error = true;
    } else {
      state.welcome_error = false;
    }
    this.setState(state);
  }

  handleDelete(i) {
    const invitees = this.state.invitees.slice(0);
    const deleted = invitees.splice(i, 1);
    const players = deleted.concat(this.state.players);
    this.setState({ invitees: invitees, players: players });
  }

  handleAddition(invitee) {
    const invitees = [].concat(this.state.invitees, invitee);
    const players = [].concat(
      this.state.players.filter((player) => player.id !== invitee.id)
    ); // Remove invitee from list of suggestions
    this.setState({ invitees: invitees, players: players });
  }

  handleValidate(invitee) {
    return this.state.invitees.findIndex((i) => i.name === invitee.name) < 0;
  }

  getPlayers() {
    const headers = getHeaders();
    fetch(playerUrl, {
      method: "GET",
      headers,
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          this.setState({
            loading: false,
            players: data
              .filter(
                (player) =>
                  player.opted_out_of_league_invites === false &&
                  player.id !== this.props.player.id
              )
              .map((player) => ({ id: player.id, name: player.screen_name })),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleSubmit(event) {
    this.setState({ loading: true });
    event.preventDefault();
    const headers = getHeaders();
    fetch(leagueUrl + "/new", {
      method: "POST",
      headers,
      body: JSON.stringify({
        name: this.state.name,
        invitees: this.state.invitees,
      }),
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          if (data.error) {
            if (data.name_unavailable) {
              this.setState({
                league_created: false,
                loading: false,
                name_error: "That name is unavailable.",
              });
            }
          } else {
            window.gtag("event", "create", {
              event_category: "league",
              event_label: `${this.state.name}`,
            });
            this.setState({
              league_created: true,
              loading: false,
              invite_token: data.invite_token,
              slug: data.slug,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getPlayers();
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <Fragment>
        <Meta
          title="Your leagues"
          description="Leagues are a fun way to enjoy Rouleur Derby."
        />

        <h1>Leagues</h1>

        {this.props.player.leagues &&
          this.props.player.leagues.length === 0 && (
            <p className="league-top-section">
              You are not in any leagues. Bummer!
            </p>
          )}
        {this.props.player.leagues && this.props.player.leagues.length > 0 && (
          <Fragment>
            <p>You are in the following leagues:</p>
            <ul className="league-list league-top-section">
              {this.props.player.leagues.map((league, i) => (
                <li
                  key={i}
                  className={`league-list__item ${
                    league.owner === this.props.player.id &&
                    "league-list__item--owner"
                  }`}
                >
                  <Link to={`/league/${league.slug}`}>{league.name}</Link>
                </li>
              ))}
            </ul>
          </Fragment>
        )}

        <h3>Start a New League</h3>

        {(!this.props.player || !this.props.player.podium_member) && (
          <Fragment>
            <p>
              Leagues are a fun way to compete against your friends and
              teammates, but leagues can only be created by members of Wide
              Angle Podium. To get this benefit,{" "}
              <a
                href="https://wideanglepodium.com/donate/"
                rel="noopener noreferrer"
                target="_blank"
              >
                join Wide Angle Podium today
              </a>{" "}
              and receive a 500-point bonus!
            </p>
            <p>
              <a
                className="button"
                href="https://wideanglepodium.com/donate/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Join Wide Angle Podium
              </a>
            </p>
          </Fragment>
        )}

        {this.state.league_created && (
          <Fragment>
            <p>
              Great!{" "}
              <Link to={`/league/${this.state.slug}`}>
                Your league has been created
              </Link>
              .
            </p>
            {this.state.players.length > 0 && (
              <p>
                Email has been sent to the players you selected to invite. Note
                that they will not show up in the standings until they accept
                this invitation.
              </p>
            )}
            <p>
              If you would like to invite more players, including people who
              have not yet joined Rouleur Derby, share this special link:
              <br />
              <strong>
                <span className="user-select">
                  http://www.rouleurderby.com/league/{this.state.slug}/
                  {this.state.invite_token}
                </span>
              </strong>
              &nbsp;.
            </p>
            <p>
              Be careful with that link. Anyone who has it will be able to join
              your league.
            </p>
          </Fragment>
        )}

        {this.state.loading && <LoadingBar />}

        {this.props.player &&
          this.props.player.podium_member &&
          !this.state.league_created &&
          !this.state.loading && (
            <Fragment>
              <p>
                Since you’re awesome and a member of Wide Angle Podium, you can
                start a league. Pick a name for your league and some players to
                invite. You’ll then be provided with a link you can use to
                invite even more players.
              </p>

              <form onSubmit={this.handleSubmit}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                />
                {this.state.name_error && (
                  <div className="input-error">
                    That league name is unavailable.
                  </div>
                )}
                <label htmlFor="welcome">Welcome message</label>

                <Textarea
                  name="welcome"
                  id="welcome"
                  value={this.state.welcome}
                  onChange={this.handleChange}
                />
                {this.state.welcome_error ? (
                  <p className="input-error">300-character maximum.</p>
                ) : (
                  <p className="input-helper">
                    Include an optional welcome message for members of your
                    league. Maximum 300 characters.
                  </p>
                )}
                <label>Invite players</label>

                <ReactTags
                  tags={this.state.invitees}
                  suggestions={this.state.players}
                  handleDelete={this.handleDelete.bind(this)}
                  handleAddition={this.handleAddition.bind(this)}
                  handleValidate={this.handleValidate.bind(this)}
                  placeholder="Add player to invite"
                  minQueryLength={1}
                />
                <p className="input-helper">
                  An email will be sent to these players inviting them to join
                  your league.
                </p>
                <button>Start League</button>
              </form>
            </Fragment>
          )}
      </Fragment>
    );
  }
}

export default Leagues;
